import seaways from 'seaways'
import { axiosClient } from '../../services/axios-client'

const http = seaways.createClient(axiosClient)

http.getBody = {
  method: 'get',
  path: '/projects/{projectId}/forms/{endpointId}/submissions/{uuid}/body'
}
http.updateCategory = {
  method: 'post',
  path:
    '/projects/{projectId}/forms/{endpointId}/submissions/{uuid}/{categoryDirection}/{category}'
}

http.remove = {
  method: 'delete',
  path: '/projects/{projectId}/forms/{endpointId}/submissions/{uuid}'
}

http.cleanTrash = {
  method: 'delete',
  path: '/projects/{projectId}/forms/{endpointId}/submissions/emptyTrash'
}

http.resend = {
  method: 'get',
  path: '/projects/{projectId}/forms/{endpointId}/submissions/{uuid}/resend'
}

http.getMessages = {
  path: '/projects/{projectId}/forms/{endpointId}/submissions',
  method: 'get'
}
http.getMessagesCount = {
  path: '/projects/{projectId}/forms/{endpointId}/submissions/count',
  method: 'get'
}

async function getBody(projectId, endpointId, uuid) {
  const requestOptions = { pathParams: { projectId, endpointId, uuid } }
  return (await http.getBody(requestOptions)).data
}

async function updateCategory({
  projectId,
  endpointId,
  uuid,
  categoryDirection,
  category
}) {
  return (
    await http.updateCategory({
      pathParams: { projectId, endpointId, uuid, categoryDirection, category }
    })
  ).data
}

async function remove({ projectId, endpointId, uuid }) {
  return (await http.remove({ pathParams: { projectId, endpointId, uuid } }))
    .data
}

async function cleanTrash({ projectId, endpointId }) {
  return (await http.cleanTrash({ pathParams: { projectId, endpointId } })).data
}

async function resend({ projectId, endpointId, uuid, pluginId }) {
  return (
    await http.resend({
      pathParams: { projectId, endpointId, uuid },
      params: { id: pluginId }
    })
  ).data
}

async function getMessagesCount({ endpointId, date, projectId }) {
  return (
    await http.getMessagesCount({
      pathParams: { endpointId, projectId },
      params: { date }
    })
  ).data
}

async function getMessages({
  endpointId,
  projectId,
  type,
  limit,
  offset,
  date,
  search
}) {
  return (
    await http.getMessages({
      pathParams: { endpointId, projectId },
      params: {
        type,
        limit,
        offset,
        date,
        search
      }
    })
  ).data
}

export default {
  getMessages,
  getMessagesCount,
  resend,
  remove,
  getBody,
  cleanTrash,
  updateCategory,
  print
}
